import React from 'react';

import Jumbotron from '../component/Jumbotron';
import CardList from '../component/CardList';
import SimpleList from '../component/SimpleList';

const Home = () => {
  return (
    <>
      <Jumbotron/>
      <SimpleList/>
      <CardList/>
    </>
  )
};
  
export default Home;